export enum MessageSender {
  user = "user",
  bot = "bot",
}

export interface Message {
  message: string;
  sender: MessageSender;
}

export enum SessionQuery {
  sessionCount = "sessionCount",
}

export interface TextResponse {
  type: "text";
  result: string;
}

export interface BinaryChunkResponse {
  type: "binary-chunk";
  id: number;
  timestamp: number;
  binary: boolean;
  value: BufferData;
}

export interface PongResponse {
  type: "pong";
  pong: "pong";
}

export interface EndResponse {
  type: "end";
}

export interface BufferData {
  type: "Buffer";
  data: number[];
}

export interface ErrorResponse {
  type: "error";
  message: string;
}

export interface BusinessUserData {
  name: string | undefined;
  userId: string | undefined;
  businessId: string | undefined;
}

export interface SessionData {
  sessionCount: number | undefined;
  countDown: string | undefined;
}

export interface MessageData {
  userMessage: string | undefined;
  businessUserData: BusinessUserData;
  sessionData: SessionData;
  isPcm: boolean;
}
